import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-grid" }
const _hoisted_2 = { class: "p-col" }
const _hoisted_3 = {
  key: 1,
  class: "placeholder"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-image fa-6x",
  title: "Nessun immagine caricata"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "p-col" }
const _hoisted_7 = { class: "p-field" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "p-grid" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "p-col-2" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-hourglass-half" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "p-col" }, "Tempo di attesa")
], -1)
const _hoisted_9 = { class: "p-grid" }
const _hoisted_10 = { class: "p-col p-offset-2" }
const _hoisted_11 = { class: "p-field" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "p-grid" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "p-col-2" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-clock" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "p-col" }, " Data e ora: ")
], -1)
const _hoisted_13 = { class: "p-grid" }
const _hoisted_14 = { class: "p-col p-offset-2" }
const _hoisted_15 = { class: "p-fluid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Image = _resolveComponent("Image")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", null, [
      _createElementVNode("h4", null, _toDisplayString(_ctx.title), 1)
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.imagePath)
          ? (_openBlock(), _createBlock(_component_Image, {
              key: 0,
              preview: "",
              src: _ctx.imagePath,
              alt: "Image",
              width: "128"
            }, null, 8, ["src"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.time), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.dateString), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_component_FloatLabel, { label: "Note" }, {
        default: _withCtx(() => [
          _createVNode(_component_Textarea, {
            readonly: "",
            autoResize: "",
            modelValue: _ctx.note
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ])
  ], 64))
}